import Main from '@/views/mian-page'

export default [
  {
    path: '/',
    name: 'home',
    meta: {
      title: '首页'
    },
    component: () => import('@/views/home/index')
  },
  {
    path: '/',
    name: '_home',
    component: Main,
    redirect: '/home',
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/login',
        name: 'login',
        meta: {
          title: '登录'
        },
        component: () => import('@/views/login/login.vue')
      },
      {
        path: '/register',
        name: 'register',
        meta: {
          title: '注册账号'
        },
        component: () => import('@/views/login/register.vue')
      },
      {
        path: '/forgetPassword',
        name: 'forgetPassword',
        meta: {
          title: '忘记密码'
        },
        component: () => import('@/views/login/forgetPassword.vue')
      },
      {
        path: '/resetPassword',
        name: 'resetPassword',
        meta: {
          title: '重置密码'
        },
        component: () => import('@/views/login/resetPassword.vue')
      },
      {
        path: '/qlink',
        name: 'qlink',
        meta: {
          hideInMenu: true
        },
        component: () => import('@/views/common/index.vue')
      },
      {
        path: '/entrust',
        name: 'entrust',
        meta: {
          title: '填写委托单',
          needLogin: true,
          needCompany: true
        },
        component: () => import('@/views/entrust/index')
      },
      {
        path: '/mall',
        name: 'mall',
        meta: {
          title: '日化商城'
        },
        component: () => import('@/views/mall/index')
      },
      {
        path: '/vip',
        name: 'vip',
        meta: {
          title: '会员专区'
        },
        component: () => import('@/views/vip-zone/index')
      },
      {
        path: '/goods/detail',
        name: 'goods',
        meta: {
          title: '商品介绍'
        },
        component: () => import('@/views/mall/detail')
      },
      {
        path: '/service',
        name: 'service',
        meta: {
          title: '检测服务'
        },
        component: () => import('@/views/service/index')
      },
      {
        path: '/service/detail',
        name: 'service',
        meta: {
          title: '检测服务'
        },
        component: () => import('@/views/service/detail')
      },
      {
        path: '/service/studyDetail',
        name: 'studyDetail',
        meta: {
          title: '在线培训'
        },
        component: () => import('@/views/service/study_detail')
      },
      {
        path: '/formula',
        name: 'formula',
        meta: {
          title: '标准配方'
        },
        component: () => import('@/views/resource/formula/index')
      },
      {
        path: '/formula/detail',
        name: 'formula',
        meta: {
          title: '标准配方',
          needLogin: true,
          needVip: true
        },
        component: () => import('@/views/resource/formula/detail')
      },
      {
        path: '/standard',
        name: 'standard',
        meta: {
          title: '检测标准'
        },
        component: () => import('@/views/resource/standard/index')
      },
      {
        path: '/search',
        name: 'search',
        meta: {
          title: '关键字搜索'
        },
        component: () => import('@/views/resource/search/index')
      },
      {
        path: '/standard/detail',
        name: 'standard',
        meta: {
          title: '检测标准',
          needLogin: true,
          needVip: true
        },
        component: () => import('@/views/resource/standard/detail')
      },
      {
        path: '/validReport',
        name: 'validReport',
        meta: {
          title: '报告验证'
        },
        component: () => import('@/views/validReport/index')
      },
      {
        path: '/laws',
        name: 'laws',
        meta: {
          title: '法律法规'
        },
        component: () => import('@/views/resource/laws/index')
      },
      {
        path: '/laws/detail',
        name: 'laws',
        meta: {
          title: '法律法规',
          needLogin: true,
          needVip: true
        },
        component: () => import('@/views/resource/laws/detail')
      },
      {
        path: '/solution',
        name: 'solution',
        meta: {
          title: '解决方案'
        },
        component: () => import('@/views/solution/index')
      },
      {
        path: '/solution/detail',
        name: 'solution',
        meta: {
          title: '解决方案'
        },
        component: () => import('@/views/solution/detail')
      },
      {
        path: '/topic',
        name: 'topic',
        meta: {
          title: '专题推荐'
        },
        component: () => import('@/views/topic/index')
      },
      {
        path: '/topic/detail',
        name: 'topic',
        meta: {
          title: '专题推荐'
        },
        component: () => import('@/views/topic/detail')
      },
      {
        path: '/reservice',
        name: 'reservice',
        meta: {
          title: '推荐检测服务'
        },
        component: () => import('@/views/reservice/index')
      },
      {
        path: '/reservice/detail',
        name: 'reservice',
        meta: {
          title: '推荐检测服务'
        },
        component: () => import('@/views/reservice/detail')
      },
      {
        path: '/reorgs',
        name: 'reorgs',
        meta: {
          title: '推荐服务机构'
        },
        component: () => import('@/views/reorgs/index')
      },
      {
        path: '/reorgs/detail',
        name: 'reorgs',
        meta: {
          title: '推荐服务机构'
        },
        component: () => import('@/views/reorgs/detail')
      },
      {
        path: '/reunit',
        name: 'reunit',
        meta: {
          title: '合作单位'
        },
        component: () => import('@/views/reunit/index')
      },
      {
        path: '/news',
        name: 'news',
        meta: {
          title: '新闻资讯'
        },
        component: () => import('@/views/news/index')
      },
      {
        path: '/news/detail',
        name: 'news',
        meta: {
          title: '新闻资讯'
        },
        component: () => import('@/views/news/detail')
      },
      {
        path: '/consulting',
        name: 'consulting',
        meta: {
          title: '在线咨询'
        },
        component: () => import('@/views/consulting/index')
      },
      {
        path: '/contactUs',
        name: 'contactUs',
        meta: {
          title: '联系我们'
        },
        component: () => import('@/views/about-us/contact-us/index')
      },
      {
        path: '/serviceProject',
        name: 'serviceProject',
        meta: {
          title: '服务项目'
        },
        component: () => import('@/views/about-us/service-project/index')
      },
      {
        path: '/deal',
        name: 'deal',
        meta: {
          title: '服务协议'
        },
        component: () => import('@/views/legal-notice/deal')
      },
      {
        path: '/privacy',
        name: 'privacy',
        meta: {
          title: '隐私保护'
        },
        component: () => import('@/views/legal-notice/privacy')
      },
      {
        path: '/rights',
        name: 'rights',
        meta: {
          title: '知识产权'
        },
        component: () => import('@/views/legal-notice/rights')
      },
      {
        path: '/cooperConsultation',
        name: 'cooperConsultation',
        meta: {
          title: '合作咨询'
        },
        component: () => import('@/views/about-us/cooper-consultation/index')
      },
      {
        path: '/userCenter',
        name: 'userCenter',
        meta: {
          title: '用户中心'
        },
        component: () => import('@/views/user-center/index'),
        children: [
          {
            path: '/userCenter/myCenter',
            name: 'myCenter',
            meta: {
              title: '我的',
              needLogin: true
            },
            component: () => import('@/views/user-center/sub-page/myCenter')
          },
          {
            path: '/userCenter/vipLevel',
            name: 'vipLevel',
            meta: {
              title: '会员等级'
            },
            component: () => import('@/views/user-center/sub-page/vipLevel')
          },
          {
            path: '/userCenter/userInfo',
            name: 'userInfo',
            meta: {
              title: '会员信息',
              needLogin: true
            },
            component: () => import('@/views/user-center/sub-page/userInfo')
          },
          {
            path: '/userCenter/myOrder',
            name: 'myOrder',
            meta: {
              title: '我的订单',
              needLogin: true
            },
            component: () => import('@/views/user-center/sub-page/myOrder')
          },
          {
            path: '/userCenter/myEntrust',
            name: 'myEntrust',
            meta: {
              title: '我的委托',
              needLogin: true,
              needCompany: true
            },
            component: () => import('@/views/user-center/sub-page/myEntrust')
          },
          {
            path: '/userCenter/myEnterpriseStandard',
            name: 'myEnterpriseStandard',
            meta: {
              title: '我的企标',
              needLogin: true,
              needCompany: true
            },
            component: () => import('@/views/user-center/sub-page/myEnterpriseStandard')
          },
          {
            path: '/userCenter/myBill',
            name: 'myBill',
            meta: {
              title: '我的账单',
              needLogin: true
            },
            component: () => import('@/views/user-center/sub-page/myBill')
          },
          {
            path: '/userCenter/myEntrustCount',
            name: 'myEntrustCount',
            meta: {
              title: '委托统计',
              needLogin: true,
              needCompany: true
            },
            component: () => import('@/views/user-center/sub-page/myEntrustCount')
          },
          {
            path: '/userCenter/myMessage',
            name: 'myMessage',
            meta: {
              title: '消息通知',
              needLogin: true
            },
            component: () => import('@/views/user-center/sub-page/myMessage')
          },
          {
            path: '/userCenter/myReport',
            name: 'myReport',
            meta: {
              title: '报告管理',
              needLogin: true,
              needCompany: true
            },
            component: () => import('@/views/user-center/sub-page/myReport')
          },
          {
            path: '/userCenter/myOrg',
            name: 'myOrg',
            meta: {
              title: '机构管理',
              needLogin: true,
              needCompany: true
            },
            component: () => import('@/views/user-center/sub-page/myOrg')
          },
          {
            path: '/userCenter/myContact',
            name: 'myContact',
            meta: {
              title: '联络人',
              needLogin: true
            },
            component: () => import('@/views/user-center/sub-page/myContact')
          },
          {
            path: '/userCenter/myAddress',
            name: 'myAddress',
            meta: {
              title: '收货地址',
              needLogin: true,
              needCompany: true
            },
            component: () => import('@/views/user-center/sub-page/myAddress')
          },
          {
            path: '/userCenter/manufacturer',
            name: 'manufacturer',
            meta: {
              title: '生产单位',
              needLogin: true,
              needCompany: true
            },
            component: () => import('@/views/user-center/sub-page/manufacturer')
          },
          {
            path: '/userCenter/stuffManage',
            name: 'stuffManage',
            meta: {
              title: '员工账号',
              needLogin: true,
              needCompany: true
            },
            component: () => import('@/views/user-center/sub-page/stuffManage')
          },
          {
            path: '/userCenter/myInvoice',
            name: 'myInvoice',
            meta: {
              title: '发票抬头',
              needLogin: true,
              needCompany: true
            },
            component: () => import('@/views/user-center/sub-page/myInvoice')
          },
          {
            path: '/userCenter/updatePassword',
            name: 'updatePassword',
            meta: {
              title: '修改密码',
              needLogin: true
            },
            component: () => import('@/views/user-center/sub-page/updatePassword')
          }
        ]
      }
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/views/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/views/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/views/error-page/404.vue')
  }
]
